import { getConfigBaseUrl } from '../../services/apiService';
import { apiCall, createApiThunk } from '../../utils/api';

export const getLayoutDataThunk = createApiThunk('GET_GRID_LAYOUT', apiCall);
export const saveLayoutDataThunk = createApiThunk('SAVE_GRID_LAYOUT', apiCall);

export const getLayoutData = (layoutId) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/${layoutId}`;
  return function (dispatch: AppDispatch) {
    dispatch(getLayoutDataThunk({ url }));
  };
};

export const saveLayoutData = (data) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/users/layouts/`;
  const method = data?.userLayoutId ? 'PUT' : 'POST';
  return dispatch(saveLayoutDataThunk({ url, method, data }));
};
